/**
 * @authorsTT
 * @date    2018-05-03 16:45:36
 */
import axios from 'axios';
import qs from 'qs';
import store from '@/store/store';
import global_ from '@/globalConfig/globalConfig';
export default function fetch(options){
    return new Promise((resolve, reject) => {
        // instance创建一个axios实例，可以自定义配置，可在 axios文档中查看详情
        const instance = axios.create({
            // 所有的请求都会带上这些配置，比如全局都要用的身份信息等。
            method: "post",
            headers: {
              "Content-Type" : "application/x-www-form-urlencoded; charset=UTF-8",
              'Cache-Control': 'no-cache',//禁止缓存
            },
            withCredentials:true,//允许跨域域名设置cookie
            timeout:60 * 1000 // 60秒超时
        });
        // http request 拦截器
        instance.interceptors.request.use(config => {
			let method = (config.method).toLowerCase();

            if (method === 'post' || method === 'delete' || method === 'put') {
                config.data = qs.stringify(config.data, {arrayFormat: 'brackets'})
            }else if(method === 'get'){
                config.params = config.data;
            }
            return config;
        });
        // http response 拦截器  与后台提前定义正确code 错误的提示
        instance.interceptors.response.use(
            response => {
                try{
                    let data = response.data;
                    if(data.result == "noauth" && !options.res){
                        // 清除store中的username
                        store.dispatch('userStore/setUserNameAsy',"");
                        // 不需要登陆就可以访问
                        let to_name = this.global_.lget("to_name");
                        if(to_name == "login" || to_name == "pwdError" || to_name == "register"){
                            return;
                        }
                        this.$router.replace({ name: "login"});

                        //关闭load加载提示
                        this.$loading.hide();
                        //关闭bootstrap弹出框
                        $('.modal').modal('hide');
                        return ;
                    }
                    return response;

                }catch(e){
                    //关闭bootstrap弹出框
                    $('.modal').modal('hide');
                }
            },
            error => {
                if (error.response) {
                   /*  switch (error.response.status) {
                        case 404:
                            this.$router.push({ path: "/error/404"});
                        break;
                        case 500:
                            this.$router.push({ path: "/error/500"});
                        break;
                        case 502:
                            this.$router.push({ path: "/error/502"});
                        break;
                        case 504:
                            this.$router.push({ path: "/error/504"});
                        break;
                    } */
                }
                return Promise.reject(error.response.data)
            }
        );

        instance(options).then(response => {
            // 把请求到的数据发到引用请求的地方
            resolve(response);
        }).catch(error => {
            // 错误日志处理
            console.log("fetch => Http请求异常："+error);
            // reject(error);
        }).finally(() => {
            // console.log("finally");
        });
    });
}


// WEBPACK FOOTER //
// ./src/util/axios/fetch.js